
export default {

  methods: {
    base64ToArrayBuffer (base64) {
      const binaryString = window.atob(base64)
      const binaryLen = binaryString.length
      const bytes = new Uint8Array(binaryLen)
      for (let i = 0; i < binaryLen; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes
    },
    saveByteArray (data, name) {
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.style = 'display: none'
      const blob = new Blob(data, { type: 'octet/stream' })
      const url = window.URL.createObjectURL(blob)
      a.href = url
      if (name) {
        a.download = name
      }
      a.click()
      window.URL.revokeObjectURL(url)
    },
    async getUrlInBase64 (url) {
      const response = await fetch(url.indexOf('/s3.amazonaws.com/') === -1 ? url : url + '&cacheblock=true')
      const blob = await response.blob()
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.readAsDataURL(blob)
      })
    },
    async forceToDownloadUrl (url, name) {
      const response = await this.getUrlInBase64(url)
      if (response) {
        const b64 = response.split(',')
        if (b64.length === 2) {
          const binary = this.base64ToArrayBuffer(b64[1])
          this.saveByteArray([binary], name)
        }
      }
    },
    base64ToBlobUrl (base64str) {
      var binary = atob(base64str)
      const len = binary.length
      const buffer = new ArrayBuffer(len)
      const view = new Uint8Array(buffer)
      for (let i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i)
      }

      const blob = new Blob([view], { type: 'application/pdf' })
      const url = URL.createObjectURL(blob)
      return url
    }
  }
}
